export const goalsAndInterestsTemplate = {
  id: 'goalsAndInterests',
  title: 'Goals & Interests',
  description: 'For short answer prompts about your academic interests, career goals, or what you hope to gain from the experience',
  wordTarget: 200,
  sections: [
    {
      id: 'the_driving_question',
      label: 'The Driving Question',
      type: 'opening',
      prompt: 'What question or problem keeps pulling you back? The thing you find yourself reading about, thinking about, or working on even when no one is asking you to.',
      coachVoice: "Start with genuine curiosity, not a career goal. 'I want to be a doctor' is a plan. 'I can't stop thinking about why the same treatment works for some patients but not others' is a driving question.",
      sample: "I keep coming back to the same puzzle: why do identical twins raised in the same household sometimes develop completely different health conditions? The gap between genetics and outcomes fascinates me.",
      minWords: 40,
      unlockWords: 20
    },
    {
      id: 'your_evidence',
      label: 'Your Evidence',
      type: 'commitment',
      prompt: 'What have you already done to explore this interest? Be specific — classes, projects, reading, conversations, experiments.',
      coachVoice: "Show, don't tell. Anyone can claim an interest. What have you actually done about it? Even small, self-directed efforts count more than listing AP classes.",
      sample: "I spent last summer reading epigenetics papers I barely understood, then started a journal tracking environmental factors in my own family's health history. My biology teacher let me present my findings to our class — the questions students asked pushed my thinking further than the research itself.",
      minWords: 50,
      unlockWords: 25
    },
    {
      id: 'the_connection',
      label: 'The Connection',
      type: 'connection',
      prompt: 'How does this program specifically help you take the next step in exploring this interest?',
      coachVoice: "Name something specific about the program — a lab, a course, a method, a mentor. Don't say 'this program will help me grow.' Say exactly what capability or access you'll gain.",
      sample: "The program's epigenetics research track with access to the biobank database would let me test patterns I've only been able to speculate about from published studies. Working with actual patient data, under real research protocols, is the leap I can't make on my own.",
      minWords: 40,
      unlockWords: 20
    },
    {
      id: 'looking_forward',
      label: 'Looking Forward',
      type: 'growth',
      prompt: 'Where does this interest lead? Not necessarily a career — how does it shape how you think or what you want to contribute?',
      coachVoice: "You don't need a 10-year plan. What matters is showing that this interest has changed how you see the world, not just what job you want.",
      sample: "Whether I end up in a research lab or a classroom, I want to be someone who asks better questions about human health — questions that account for the messy reality that biology and environment are inseparable.",
      minWords: 30,
      unlockWords: 15
    }
  ]
};
